import React from 'react';
import type {RuleConditionState} from '../../../modules/ruleengine/types';
import {DURATION_TRIGGER_MIN_VALUE, DURATION_TRIGGER_MAX_VALUE} from '../../../modules/ruleengine/config/consts';
type Props = {
	disabled: boolean;
	onChange: (arg0: Partial<RuleConditionState>) => void;
	value?: number;
};

const TriggerOptionalSettingsMinutesInput = ({disabled, value, onChange}: Props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const {value} = event.target;
		onChange({
			duration: {
				durationInMin: parseInt(value, 10) || undefined
			},
			counter: undefined
		});
	};

	return (
		<input
			data-testid="optional-setting-value"
			type="number"
			disabled={disabled}
			min={DURATION_TRIGGER_MIN_VALUE}
			max={Math.floor(DURATION_TRIGGER_MAX_VALUE)}
			value={value || ''}
			onChange={handleChange}
		/>
	);
};

export default TriggerOptionalSettingsMinutesInput;
